import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useQueryParam = (paramKey: string) => {
  const location = useLocation();
  let history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const [params, setParams] = useState<string | null>(() => queryParams.get(paramKey));

  useEffect(() => {
    const paramValue = queryParams.get(paramKey);
    if (!paramValue) return;

    history.replace({
      search: queryParams.toString(),
    });
    setParams(paramValue);
  }, [location.search]);

  const patchQueryParam = (queryParam: string, newParamValue: string) => {
    if (newParamValue) {
      history.replace({
        search: `${queryParam}=${newParamValue}`,
      });
      setParams(newParamValue);
    }
  };

  return { params, patchQueryParam };
};

export default useQueryParam;
